import { generateId } from '../../utils/generate-id';

export type ToastType = 'success' | 'error' | 'warning' | 'info';

export type Toast = {
  id: string;
  message: string;
  type: ToastType;
  timeout: number;
}

export const getDefaultToast = (): Toast => ({
  id: generateId(),
  message: '',
  type: 'success',
  timeout: 7000,
});
